import ShowroomDownloadsDeleteButton from "./showroom-downloads-delete-button"

export default ShowroomDownloadsDeleteButton;